
import { Script } from 'gatsby'

import Layout from './src/layout/Layout'

const GTM_ID = process.env.GTM_ID


export const wrapPageElement = ({ element, props }) => {
	return <Layout	{...props}>

		{ element }

		{ process.env.NODE_ENV === 'production' && <>
			<Script id='gtag-config' strategy='idle'>
				{`
					window.dataLayer = window.dataLayer || [];
					window.gtag = function() { dataLayer.push(arguments); };
					gtag('consent', 'default', {
						ad_storage: 'denied',
						ad_user_data: 'denied',
						ad_personalization: 'denied',
						analytics_storage: 'denied',
						functionality_storage: 'denied',
						personalization_storage: 'denied',
						security_storage: 'granted',
						wait_for_update: 500
					});
					gtag('js', new Date());
					gtag('config', '${GTM_ID}');
				`}
			</Script>
			<Script strategy='idle' src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`} />
			<Script strategy='idle' src='/cookie-consent.js?v=2026-06-15' />
			<Script strategy='idle' src='https://comparamais.leado.pl/js/leado-subscribe.js' />
		</> }

		<Script id='fiizy-analytics'>{`
			var app = app || {};
			app.config = {
				version: "${process.env.GATSBY_FIIZY_VERSION}",
				lang: "${process.env.GATSBY_FIIZY_LANGUAGE}",
				locale: "${process.env.GATSBY_FIIZY_LOCALE}",
				apiUrl: "${process.env.GATSBY_FIIZY_API_URL}",
				channelHash: "${process.env.GATSBY_FIIZY_CHANNEL_HASH}",
				seoChannelHash: "${process.env.GATSBY_FIIZY_SEO_CHANNEL_HASH}",
				calculatorChannelHash: "${process.env.GATSBY_FIIZY_CALCULATOR_CHANNEL_HASH}",
				clientBundleIdentifier: "${process.env.GATSBY_FIIZY_CLIENT_BUNDLE_IDENTIFIER}",
				forceChannel: "false",
			};
		`}</Script>
		<Script strategy='idle' src='/fiizy-analytics.js' />

	</Layout>
}


export const onRenderBody = ({ 
	setHtmlAttributes, 
	setHeadComponents,
	setPreBodyComponents,
}) => {

	setHtmlAttributes({ lang: 'pt-PT' })

	setHeadComponents([
		<link key="signika-latin-ext" rel="preload" as="font" type="font/woff2" href="/fonts/Signika-latin-ext.woff2" crossOrigin="anonymous" />,
		<link key="signika-latin" rel="preload" as="font" type="font/woff2" href="/fonts/Signika-latin.woff2" crossOrigin="anonymous" />,

		<link key='sitemap' rel='sitemap' type='application/xml' href='/sitemap-index.xml' />,
	])

	if (process.env.NODE_ENV === 'production') {
		setPreBodyComponents([
			<noscript key='gtm-noscript'>
				<iframe height='0' width='0' style={{ display: 'none', visibility: 'hidden' }} 
					src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}					
				/>
			</noscript>
		])
	}
}


export const onPreRenderHTML = ({ getHeadComponents, replaceHeadComponents }) => {

	const headComponents = getHeadComponents()

	headComponents.sort((a, b) => {
		if (a.props?.rel === 'dns-prefetch' || a.props?.rel === 'preload') return -1
		if (b.props?.rel === 'dns-prefetch' || b.props?.rel === 'preload') return 1
		return 0
	})

	replaceHeadComponents(headComponents)
}

